module.exports = __webpack_public_path__ + "static/Ice.686ac2cb.png";